import { render, staticRenderFns } from "./btn-get-user-info.mpx?vue&type=template&id=ed87ee84&isComponent&outputPath=components%2Fbtn-get-user-info1dbb07e4%2Findex"
import script from "./btn-get-user-info.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-get-user-info1dbb07e4%2Findex"
export * from "./btn-get-user-info.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-get-user-info1dbb07e4%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports